<template>
  <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">مدیریت تم</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="background-main mx-2 mt-3">
            <v-col cols="12">
              <v-card height="73vh" elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="3" v-for="item in themeOptions" :key="item.id">
                      <v-card height="20vh" :class="item.selectClass" @click="changeTheme(item.value)">
                        <v-row no-gutters :class="item.firstDiv">
                          <v-col cols="12">
                            <v-row no-gutters :class="item.secondDiv"></v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                      <v-row class="mt-4">
                        <v-spacer></v-spacer>
                        <span :class="item.textClass">{{ item.text }}</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import SharedMixin from '@/Mixins/Shared';
export default {
  name: 'themeManagment',
  title: 'تم',
  mixins: [SharedMixin],
  inject: ['load', 'tableImg', 'tableTitleImage'],
  created() {
    this.$root.$refs.ThemeManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      theme: '',
      contrast: '',
      themeOptions: [
        {
          text: 'آبی',
          value: 'blue',
          firstDiv: 'blue-first-div',
          secondDiv: 'blue-second-div',
          selectClass: 'card-theme-main selectedTheme',
          textClass: 'selected-theme-text',
        },
        {
          text: 'قرمز',
          value: '2',
          firstDiv: 'red-first-div',
          secondDiv: 'red-second-div',
          selectClass: 'card-theme-main',
          textClass: 'none-selected-theme-text',
        },
        {
          text: 'سبز',
          value: '3',
          firstDiv: 'green-first-div',
          secondDiv: 'green-second-div',
          selectClass: 'card-theme-main',
          textClass: 'none-selected-theme-text',
        },
        {
          text: 'فیروزه ای',
          value: '4',
          firstDiv: 'four-first-div',
          secondDiv: 'four-second-div',
          selectClass: 'card-theme-main',
          textClass: 'none-selected-theme-text',
        },
        {
          text: 'نارنجی',
          value: '5',
          firstDiv: 'five-first-div',
          secondDiv: 'five-second-div',
          selectClass: 'card-theme-main',
          textClass: 'none-selected-theme-text',
        },
        {
          text: 'بنفش',
          value: '6',
          firstDiv: 'six-first-div',
          secondDiv: 'six-second-div',
          selectClass: 'card-theme-main',
          textClass: 'none-selected-theme-text',
        },
        {
          text: 'سرخ آبی',
          value: '7',
          firstDiv: 'seven-first-div',
          secondDiv: 'seven-second-div',
          selectClass: 'card-theme-main',
          textClass: 'none-selected-theme-text',
        },
        {
          text: 'صورتی',
          value: '8',
          firstDiv: 'eight-first-div',
          secondDiv: 'eight-second-div',
          selectClass: 'card-theme-main',
          textClass: 'none-selected-theme-text',
        },
      ],
    };
  },
  methods: {
    mounte: function () {
      let theme = localStorage.getItem('theme');
      for (let i = 0; i < this.themeOptions.length; i++) {
        if (theme == this.themeOptions[i].value) {
          this.themeOptions[i].selectClass = 'card-theme-main selectedTheme';
          this.themeOptions[i].textClass = 'selected-theme-text';
        } else {
          this.themeOptions[i].selectClass = 'card-theme-main';
          this.themeOptions[i].textClass = 'none-selected-theme-text';
        }
      }
    },
    changeTheme: function (text) {
      for (let i = 0; i < this.themeOptions.length; i++) {
        if (text == this.themeOptions[i].value) {
          this.themeOptions[i].selectClass = 'card-theme-main selectedTheme';
          this.themeOptions[i].textClass = 'selected-theme-text';
        } else {
          this.themeOptions[i].selectClass = 'card-theme-main';
          this.themeOptions[i].textClass = 'none-selected-theme-text';
        }
      }
      if (text == 'blue') {
        localStorage.setItem('theme', 'blue');
        localStorage.setItem('darkColor', '#04468B');
        localStorage.setItem('lightColor', '#0A6ADA');
        localStorage.setItem('iconColor', '#0A6ADA');
        localStorage.setItem('background', '#F6FBFF');
        localStorage.setItem('textLightColor', '#4173a8');
        localStorage.setItem('modalBorder', '#04468B');
        localStorage.setItem('oneFieldcolor', '#81A3C5');
        localStorage.setItem('newCallEffect', '#70B2FF');
        this.$vuetify.theme.currentTheme.darkColor = '#04468B';
        this.$vuetify.theme.currentTheme.lightColor = '#0A6ADA';
        this.$vuetify.theme.currentTheme.iconColor = '#0A6ADA';
        this.$vuetify.theme.currentTheme.background = '#F6FBFF';
        this.$vuetify.theme.currentTheme.textLightColor = '#4173a8';
        this.$vuetify.theme.currentTheme.modalBorder = '#04468B';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#81A3C5';
        this.$vuetify.theme.currentTheme.newCallEffect = '#70B2FF';
      } else if (text == '2') {
        localStorage.setItem('theme', '2');
        localStorage.setItem('darkColor', '#943A2D');
        localStorage.setItem('lightColor', '#DA6757');
        localStorage.setItem('iconColor', '#DA6757');
        localStorage.setItem('background', '#FFF5F3');
        localStorage.setItem('textLightColor', '#DA6757');
        localStorage.setItem('modalBorder', '#B17066');
        localStorage.setItem('oneFieldcolor', '#C99C96');
        localStorage.setItem('newCallEffect', '#F89B8E');
        this.$vuetify.theme.currentTheme.darkColor = '#943A2D';
        this.$vuetify.theme.currentTheme.lightColor = '#DA6757';
        this.$vuetify.theme.currentTheme.iconColor = '#DA6757';
        this.$vuetify.theme.currentTheme.background = '#FFF5F3';
        this.$vuetify.theme.currentTheme.textLightColor = '#DA6757';
        this.$vuetify.theme.currentTheme.modalBorder = '#B17066';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#C99C96';
        this.$vuetify.theme.currentTheme.newCallEffect = '#F89B8E';
        // green
      } else if (text == '3') {
        localStorage.setItem('theme', '3');
        localStorage.setItem('darkColor', '#1EAA6E');
        localStorage.setItem('lightColor', '#2EDF93');
        localStorage.setItem('iconColor', '#2EDF93');
        localStorage.setItem('background', '#ECFFF7');
        localStorage.setItem('textLightColor', '#52BF90');
        localStorage.setItem('modalBorder', '#1EAA6E');
        localStorage.setItem('oneFieldcolor', '#8FD4B7');
        localStorage.setItem('newCallEffect', '#6BFBBD');
        this.$vuetify.theme.currentTheme.darkColor = '#1EAA6E';
        this.$vuetify.theme.currentTheme.lightColor = '#2EDF93';
        this.$vuetify.theme.currentTheme.iconColor = '#2EDF93';
        this.$vuetify.theme.currentTheme.background = '#ECFFF7';
        this.$vuetify.theme.currentTheme.textLightColor = '#52BF90';
        this.$vuetify.theme.currentTheme.modalBorder = '#1EAA6E';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#8FD4B7';
        this.$vuetify.theme.currentTheme.newCallEffect = '#6BFBBD';
      } else if (text == '4') {
        localStorage.setItem('theme', '4');
        localStorage.setItem('darkColor', '#029280');
        localStorage.setItem('lightColor', '#21B6A3');
        localStorage.setItem('iconColor', '#21B6A3');
        localStorage.setItem('background', '#F8FFFE');
        localStorage.setItem('textLightColor', '#40AD9F');
        localStorage.setItem('modalBorder', '#029280');
        localStorage.setItem('oneFieldcolor', '#80C8BF');
        localStorage.setItem('newCallEffect', '#61E8D7');
        this.$vuetify.theme.currentTheme.darkColor = '#029280';
        this.$vuetify.theme.currentTheme.lightColor = '#21B6A3';
        this.$vuetify.theme.currentTheme.iconColor = '#21B6A3';
        this.$vuetify.theme.currentTheme.background = '#F8FFFE';
        this.$vuetify.theme.currentTheme.textLightColor = '#40AD9F';
        this.$vuetify.theme.currentTheme.modalBorder = '#029280';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#80C8BF';
        this.$vuetify.theme.currentTheme.newCallEffect = '#61E8D7';
        // orange
      } else if (text == '5') {
        localStorage.setItem('theme', '5');
        localStorage.setItem('darkColor', '#BD4E15');
        localStorage.setItem('lightColor', '#E9881C');
        localStorage.setItem('iconColor', '#E9881C');
        localStorage.setItem('background', '#FFF7F2');
        localStorage.setItem('textLightColor', '#CD784C');
        localStorage.setItem('modalBorder', '#BD4E15');
        localStorage.setItem('oneFieldcolor', '#DEA78A');
        localStorage.setItem('newCallEffect', '#FFBD74');
        this.$vuetify.theme.currentTheme.darkColor = '#BD4E15';
        this.$vuetify.theme.currentTheme.lightColor = '#E9881C';
        this.$vuetify.theme.currentTheme.iconColor = '#E9881C';
        this.$vuetify.theme.currentTheme.background = '#FFF7F2';
        this.$vuetify.theme.currentTheme.textLightColor = '#CD784C';
        this.$vuetify.theme.currentTheme.modalBorder = '#BD4E15';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#DEA78A';
        this.$vuetify.theme.currentTheme.newCallEffect = '#FFBD74';
      } else if (text == '6') {
        localStorage.setItem('theme', '6');
        localStorage.setItem('darkColor', '#2F3765');
        localStorage.setItem('lightColor', '#4D5992');
        localStorage.setItem('iconColor', '#4D5992');
        localStorage.setItem('background', '#F3F5FF');
        localStorage.setItem('textLightColor', '#60678B');
        localStorage.setItem('modalBorder', '#2F3765');
        localStorage.setItem('oneFieldcolor', '#979BB2');
        localStorage.setItem('newCallEffect', '#9BA5D0');
        this.$vuetify.theme.currentTheme.darkColor = '#2F3765';
        this.$vuetify.theme.currentTheme.lightColor = '#4D5992';
        this.$vuetify.theme.currentTheme.iconColor = '#4D5992';
        this.$vuetify.theme.currentTheme.background = '#F3F5FF';
        this.$vuetify.theme.currentTheme.textLightColor = '#60678B';
        this.$vuetify.theme.currentTheme.modalBorder = '#2F3765';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#979BB2';
        this.$vuetify.theme.currentTheme.newCallEffect = '#9BA5D0';
      } else if (text == '7') {
        // pink
        localStorage.setItem('theme', '7');
        localStorage.setItem('darkColor', '#76143D');
        localStorage.setItem('lightColor', '#BA2E69');
        localStorage.setItem('iconColor', '#BA2E69');
        localStorage.setItem('background', '#FFF3F8');
        localStorage.setItem('textLightColor', '#984C6C');
        localStorage.setItem('modalBorder', '#76143D');
        localStorage.setItem('oneFieldcolor', '#BB899E');
        localStorage.setItem('newCallEffect', '#FF94C1');
        this.$vuetify.theme.currentTheme.darkColor = '#76143D';
        this.$vuetify.theme.currentTheme.lightColor = '#BA2E69';
        this.$vuetify.theme.currentTheme.iconColor = '#BA2E69';
        this.$vuetify.theme.currentTheme.background = '#FFF3F8';
        this.$vuetify.theme.currentTheme.textLightColor = '#984C6C';
        this.$vuetify.theme.currentTheme.modalBorder = '#76143D';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#BB899E';
        this.$vuetify.theme.currentTheme.newCallEffect = '#FF94C1';
      } else if (text == '8') {
        localStorage.setItem('theme', '8');
        localStorage.setItem('darkColor', '#D20F6D');
        localStorage.setItem('lightColor', '#FF48AB');
        localStorage.setItem('iconColor', '#FF48AB');
        localStorage.setItem('background', '#FFF0F7');
        localStorage.setItem('textLightColor', '#DD4B91');
        localStorage.setItem('modalBorder', '#D20F6D');
        localStorage.setItem('oneFieldcolor', '#E887B6');
        localStorage.setItem('newCallEffect', '#FBA8D5');
        this.$vuetify.theme.currentTheme.darkColor = '#D20F6D';
        this.$vuetify.theme.currentTheme.lightColor = '#FF48AB';
        this.$vuetify.theme.currentTheme.iconColor = '#FF48AB';
        this.$vuetify.theme.currentTheme.background = '#FFF0F7';
        this.$vuetify.theme.currentTheme.textLightColor = '#DD4B91';
        this.$vuetify.theme.currentTheme.modalBorder = '#D20F6D';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#E887B6';
        this.$vuetify.theme.currentTheme.newCallEffect = '#FBA8D5';
      } else if (text == '9') {
        localStorage.setItem('theme', '9');
        localStorage.setItem('darkColor', '#252525');
        localStorage.setItem('lightColor', '#555555');
        localStorage.setItem('iconColor', '#555555');
        localStorage.setItem('background', '#191919');
        localStorage.setItem('textLightColor', '#FFFFFF');
        localStorage.setItem('modalBorder', '#252525');
        localStorage.setItem('oneFieldcolor', '#7D7E81');
        localStorage.setItem('newCallEffect', '#999999');
        this.$vuetify.theme.currentTheme.darkColor = '#252525';
        this.$vuetify.theme.currentTheme.lightColor = '#555555';
        this.$vuetify.theme.currentTheme.iconColor = '#555555';
        this.$vuetify.theme.currentTheme.background = '#191919';
        this.$vuetify.theme.currentTheme.textLightColor = '#FFFFFF';
        this.$vuetify.theme.currentTheme.modalBorder = '#252525';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#7D7E81';
        this.$vuetify.theme.currentTheme.newCallEffect = '#999999';
      }
      window.location.reload();
    },
  },
};
</script>
<style scoped>
.items-back {
  background: var(--dark-color) !important;
  position: absolute;
  height: 15vh;
  width: 13%;
  border-radius: 14px !important;
}

.items-back-add {
  background: var(--one-field-color) !important;
  position: absolute;
  height: 15vh;
  width: 13%;
  border-radius: 14px !important;
}

.items-circle {
  width: 7.5vh;
  height: 7.5vh;
  border-radius: 50% !important;
  background: white;
  margin-right: -3.7vh;
}

.items-space {
  height: 1.75vh;
}

.items-circle-above {
  width: 5vh;
  height: 5vh;
  border-radius: 50% !important;
  background: var(--dark-color);
  margin-right: 1vh;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}

.items-circle-above-add {
  width: 5vh;
  height: 5vh;
  border-radius: 50% !important;
  background: var(--one-field-color);
  margin-right: 1vh;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}

.items-space-above {
  height: 1.2vh;
}

.items-index {
  color: white;
}

.items-index-space {
  margin-top: 1.3vh !important;
}

.items-card-text-space {
  margin-top: 4vh;
}

.item-add-card {
  border: 2px dashed #c0d1e2 !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

/*firsst divs*/
.blue-first-div {
  height: 20vh !important;
  border-top: 5vh solid #0a6ada !important;
  border-right: 5vh solid #0a6ada !important;
  border-left: none !important;
  border-bottom: none !important;
}

.red-first-div {
  height: 20vh !important;
  border-top: 5vh solid #da6757 !important;
  border-right: 5vh solid #da6757 !important;
  border-left: none !important;
  border-bottom: none !important;
}

.green-first-div {
  height: 20vh !important;
  border-top: 5vh solid #2edf93 !important;
  border-right: 5vh solid #2edf93 !important;
  border-left: none !important;
  border-bottom: none !important;
}

.four-first-div {
  height: 20vh !important;
  border-top: 5vh solid #21b6a3 !important;
  border-right: 5vh solid #21b6a3 !important;
  border-left: none !important;
  border-bottom: none !important;
}

.five-first-div {
  height: 20vh !important;
  border-top: 5vh solid #e9881c !important;
  border-right: 5vh solid #e9881c !important;
  border-left: none !important;
  border-bottom: none !important;
}

.six-first-div {
  height: 20vh !important;
  border-top: 5vh solid #4d5992 !important;
  border-right: 5vh solid #4d5992 !important;
  border-left: none !important;
  border-bottom: none !important;
}

.seven-first-div {
  height: 20vh !important;
  border-top: 5vh solid #ba2e69 !important;
  border-right: 5vh solid #ba2e69 !important;
  border-left: none !important;
  border-bottom: none !important;
}

.eight-first-div {
  height: 20vh !important;
  border-top: 5vh solid #ff48ab !important;
  border-right: 5vh solid #ff48ab !important;
  border-left: none !important;
  border-bottom: none !important;
}

.nine-first-div {
  height: 20vh !important;
  border-top: 5vh solid #252525 !important;
  border-right: 5vh solid #252525 !important;
  border-left: none !important;
  border-bottom: none !important;
}

/*second div*/
.blue-second-div {
  height: 15vh !important;
  border-top: 5vh solid #04468b !important;
  border-right: 5vh solid #04468b !important;
  border-left: none !important;
  border-bottom: none !important;
}

.red-second-div {
  height: 15vh !important;
  border-top: 5vh solid #943a2d !important;
  border-right: 5vh solid #943a2d !important;
  border-left: none !important;
  border-bottom: none !important;
}

.green-second-div {
  height: 15vh !important;
  border-top: 5vh solid #1eaa6e !important;
  border-right: 5vh solid #1eaa6e !important;
  border-left: none !important;
  border-bottom: none !important;
}

.four-second-div {
  height: 15vh !important;
  border-top: 5vh solid #029280 !important;
  border-right: 5vh solid #029280 !important;
  border-left: none !important;
  border-bottom: none !important;
}

.five-second-div {
  height: 15vh !important;
  border-top: 5vh solid #bd4e15 !important;
  border-right: 5vh solid #bd4e15 !important;
  border-left: none !important;
  border-bottom: none !important;
}

.six-second-div {
  height: 15vh !important;
  border-top: 5vh solid #2f3765 !important;
  border-right: 5vh solid #2f3765 !important;
  border-left: none !important;
  border-bottom: none !important;
}

.seven-second-div {
  height: 15vh !important;
  border-top: 5vh solid #76143d !important;
  border-right: 5vh solid #76143d !important;
  border-left: none !important;
  border-bottom: none !important;
}

.eight-second-div {
  height: 15vh !important;
  border-top: 5vh solid #d20f6d !important;
  border-right: 5vh solid #d20f6d !important;
  border-left: none !important;
  border-bottom: none !important;
}

.nine-second-div {
  height: 15vh !important;
  border-top: 5vh solid #555555 !important;
  border-right: 5vh solid #555555 !important;
  border-left: none !important;
  border-bottom: none !important;
}

.card-theme-main {
  border-radius: 15px !important;
}

.selectedTheme {
  border: 2px solid #04468b !important;
}

.none-selected-theme-text {
  font-size: 14px;
}

.selected-theme-text {
  font-size: 16px;
  font-weight: bold;
}
</style>
